import { AsyncStoreItem } from '@lib/store';
import { PetRakunoriResponse } from 'src/sdk-servicing';

/**
 * PetRakunori model
 */
export interface PetRakunoriModel {
  model: PetRakunoriResponse | null;
}

/**
 * PetRakunoriResponse model details
 */
export interface PetRakunoriStateDetails extends AsyncStoreItem {}

/**
 * PetRakunori store state
 */
export interface PetRakunoriState extends PetRakunoriStateDetails, PetRakunoriModel {}

/**
 * Name of the PetRakunori Store
 */
export const PET_RAKUNORI_STORE_NAME = 'petRakunori';

/**
 * PetRakunori Store Interface
 */
export interface PetRakunoriStore {
  /** PetRakunori state */
  [PET_RAKUNORI_STORE_NAME]: PetRakunoriState;
}
